<template>
  <div class="storageContract">
    <h2>仓储合同</h2>
    <el-form :inline="true">
      <el-form-item label="合同日期">
        <el-date-picker v-model="searchParam.contractDates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchParam.reviewState" filterable style="width: 120px;" clearable>
          <el-option label="未审核" value="none" />
          <el-option label="通过" value="pass" />
          <el-option label="不通过" value="unpass" />
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="searchParam.noteLike" clearable style="width: 220px;" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">新建</el-button>
          <el-button type="warning" :disabled="!(show.selected.length == 1)" @click="update()">详情</el-button>
          <el-button type="info" :disabled="!(show.selected.length == 1)" @click="review()">审核</el-button>
          <el-button type="danger" :disabled="!(show.selected.length >= 1)" @click="del()" :loading="show.saving">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 310px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column width="55" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">详情</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="contractDate" label="合同日期" width="120" show-overflow-tooltip />
      <el-table-column prop="qualification" label="资质证书" width="120" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.qualification">有</el-text>
          <el-text v-else>无</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="contractDraft" label="合同草稿" width="120" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.contractDraft">有</el-text>
          <el-text v-else>无</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="reviewState" label="审核状态" width="120" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.reviewState == 'none'">未审核</el-text>
          <el-text type="success" v-if="scope.row.reviewState == 'pass'">通过</el-text>
          <el-text type="danger" v-if="scope.row.reviewState == 'unpass'">不通过</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="reviewNote" label="审核备注" show-overflow-tooltip />
      <el-table-column prop="contract" label="合同原件" width="120" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.contract">有</el-text>
          <el-text v-else>无</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" show-overflow-tooltip />
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[300, 500, 1000, 2000]" background layout="total, sizes, prev, pager, next, jumper" :total="data.total" @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  total: 0,
  list: [],
})

const show = reactive({
  saving: false,
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 300
  searchParam.contractDates = []
  searchParam.reviewState = null
  searchParam.noteLike = null
}
resetSearchParam()
const beforeSearchParam = cache.getObject(cache.keys.pageParam + 'storageContract')
if (beforeSearchParam) {
  Object.assign(searchParam, beforeSearchParam)
  cache.setObject(cache.keys.pageParam + 'storageContract', null)
}

const commitFindList = () => {
  const params = {}
  params.pageNum = searchParam.pageNum
  params.pageSize = searchParam.pageSize
  if (searchParam.contractDates && searchParam.contractDates.length == 2) {
    params.contractDateGe = util.parseTime(searchParam.contractDates[0], '{y}-{m}-{d}')
    params.contractDateLe = util.parseTime(searchParam.contractDates[1], '{y}-{m}-{d}')
  }
  params.contractType = 'storage'
  params.reviewState = searchParam.reviewState
  params.noteLike = searchParam.noteLike
  api.get('/backend/contract/page', { params: params }).then(res => {
    data.list = res.list
    data.total = res.total
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'storageContract', searchParam)
  cache.setObject(cache.keys.pageParam + 'storageContractDetail', null)
  router.push('/storageContractDetail')
}

const update = (row) => {
  cache.setObject(cache.keys.pageParam + 'storageContract', searchParam)
  const contract = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'storageContractDetail', contract)
  router.push('/storageContractDetail')
}

const del = () => {
  if (show.saving) {
    return
  }
  const ids = tabRef.value.getSelectionRows().map(contract => contract.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    show.saving = true
    api.post('/backend/contract/del', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    }).finally(() => {
      show.saving = false
    })
  })
}

const review = () => {
  const storagePay = tabRef.value.getSelectionRows()[0]
  if (storagePay.reviewState != 'none') {
    ElMessage.error('此合同已审核')
    return
  }
  cache.setObject(cache.keys.pageParam + 'storageContract', searchParam)
  cache.setObject(cache.keys.pageParam + 'storageContractReview', storagePay)
  router.push('/storageContractReview')
}
</script>

<style lang="less"></style>